// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/ai/v1/agent.proto (package vitesse.ai.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_vitesse_v1_common } from "../../v1/common_pb.js";
/**
 * Describes the file vitesse/ai/v1/agent.proto.
 */
export const file_vitesse_ai_v1_agent = /*@__PURE__*/ fileDesc("Chl2aXRlc3NlL2FpL3YxL2FnZW50LnByb3RvEg12aXRlc3NlLmFpLnYxIkIKDlJ1bkNvbnN0cmFpbnRzEhAKCHN0ZXBfY2FwGAEgASgNEhIKCmJ1ZGdldF91c2QYAiABKAFKBAgDEARKBAgEEAUipQEKCUFnZW50VGFzaxINCgVsYWJlbBgGIAEoCRIRCglvYmplY3RpdmUYASABKAkSEgoKaW5wdXRfanNvbhgCIAEoCRIYChBkZWxpdmVyYWJsZV9zcGVjGAMgASgJEjIKC2NvbnN0cmFpbnRzGAQgASgLMh0udml0ZXNzZS5haS52MS5SdW5Db25zdHJhaW50cxIUCgxjb250ZXh0X3JlZnMYBSADKAki7AEKC0FnZW50UmV0dXJuEiIKBnJlc3VsdBgBIAEoCzISLnZpdGVzc2UudjEuUmVzdWx0EhgKEGRlbGl2ZXJhYmxlX2pzb24YAiABKAkSNgoPdGVybWluYWxfcmVhc29uGAMgASgOMh0udml0ZXNzZS5haS52MS5UZXJtaW5hbFJlYXNvbhIRCgl1bnNvdXJjZWQYBiADKAkSFQoNbWlzYXR0cmlidXRlZBgHIAMoCRIPCgd1bmNpdGVkGAggAygJEhEKCWNpdGF0aW9ucxgJIAMoCRINCgVhc2tlZBgKIAMoCUoECAQQBUoECAUQBiKlAQoIUnVuVXNhZ2USFAoMaW5wdXRfdG9rZW5zGAEgASgEEhUKDW91dHB1dF90b2tlbnMYAiABKAQSGAoQcmVhc29uaW5nX3Rva2VucxgDIAEoBBIVCg1jYWNoZWRfdG9rZW5zGAQgASgEEhAKCGNvc3RfdXNkGAUgASgBEhIKCnRvb2xfY2FsbHMYBiABKA0SFQoNdG9vbF9mYWlsdXJlcxgHIAEoDSKhBgoIQWdlbnRSdW4SDgoGcnVuX2lkGAEgASgJEhcKD2NvbnZlcnNhdGlvbl9pZBgCIAEoCRITCgtyb290X3J1bl9pZBgDIAEoCRIVCg1wYXJlbnRfcnVuX2lkGAQgASgJEiQKHHNwYXduZWRfZnJvbV9jb252ZXJzYXRpb25faWQYHCABKAkSDQoFZGVwdGgYBSABKA0SDgoGYXdhaXRzGAYgAygJEhgKEGNvbnRpbnVlc19ydW5faWQYFiABKAkSEgoKcGFyZW50X3NlcRgVIAEoBBIRCglleHBlcnRfaWQYByABKAkSDQoFbW9kZWwYCCABKAkSDgoGZWZmb3J0GAkgASgJEiYKBHRhc2sYCiABKAsyGC52aXRlc3NlLmFpLnYxLkFnZW50VGFzaxIoCgZzdGF0dXMYCyABKA4yGC52aXRlc3NlLmFpLnYxLlJ1blN0YXR1cxI2Cg90ZXJtaW5hbF9yZWFzb24YDCABKA4yHS52aXRlc3NlLmFpLnYxLlRlcm1pbmFsUmVhc29uEicKA3JldBgNIAEoCzIaLnZpdGVzc2UuYWkudjEuQWdlbnRSZXR1cm4SFQoNc3RhcnRlZF9hdF9ucxgOIAEoAxITCgtlbmRlZF9hdF9ucxgPIAEoAxISCgpzdGVwX2NvdW50GBAgASgNEiYKBXVzYWdlGBEgASgLMhcudml0ZXNzZS5haS52MS5SdW5Vc2FnZRIuCg1zdWJ0cmVlX3VzYWdlGBIgASgLMhcudml0ZXNzZS5haS52MS5SdW5Vc2FnZRIQCghoZWFkbGluZRgTIAEoCRIWCg5oZWFkbGluZV9hdF9ucxgUIAEoAxIPCgdwYXJ0aWFsGB0gASgJEhUKDXBhcnRpYWxfYXRfbnMYHiABKAMSDQoFc3RhbGUYFyABKAgSFQoNc3RhbGVfYmVjYXVzZRgYIAEoCRITCgtzdGFsZV9hdF9ucxgZIAEoAxIRCglzdGVlcl9zZXEYGiABKAQSMAoMcHJpb3JfZW5kaW5nGBsgASgLMhoudml0ZXNzZS5haS52MS5BZ2VudFJldHVybiKKAgoIUnVuRXZlbnQSKgoEa2luZBgBIAEoDjIcLnZpdGVzc2UuYWkudjEuUnVuRXZlbnQuS2luZBIOCgZydW5faWQYAiABKAkSJAoDcnVuGAMgASgLMhcudml0ZXNzZS5haS52MS5BZ2VudFJ1bhINCgVhdF9ucxgIIAEoAyJ1CgRLaW5kEhQKEEtJTkRfVU5TUEVDSUZJRUQQABIUChBLSU5EX1JVTl9TVEFSVEVEEAESDwoLS0lORF9TVEFUVVMQAhINCglLSU5EX1NURVAQAxIVChFLSU5EX1JVTl9GSU5JU0hFRBAFIgQIBBAEIgQIBhAGSgQIBBAFSgQIBRAGSgQIBhAHSgQIBxAIIo8CCgxMZWFzZVJlcXVlc3QSMgoGYWN0aW9uGAEgASgOMiIudml0ZXNzZS5haS52MS5MZWFzZVJlcXVlc3QuQWN0aW9uEhMKC3Jvb3RfcnVuX2lkGAIgASgJEhEKCWRyaXZlcl9pZBgDIAEoCRIqCgRraW5kGAQgASgOMhwudml0ZXNzZS5haS52MS5SdW5MZWFzZS5LaW5kEg4KBnR0bF9tcxgFIAEoDRINCgVlcG9jaBgGIAEoBCJYCgZBY3Rpb24SFgoSQUNUSU9OX1VOU1BFQ0lGSUVEEAASEAoMQUNUSU9OX0NMQUlNEAESEAoMQUNUSU9OX1JFTkVXEAISEgoOQUNUSU9OX1JFTEVBU0UQAyJYCgpMZWFzZVJlcGx5EiIKBnJlc3VsdBgBIAEoCzISLnZpdGVzc2UudjEuUmVzdWx0EiYKBWxlYXNlGAIgASgLMhcudml0ZXNzZS5haS52MS5SdW5MZWFzZSKhAQoLUnVuUHJvZ3Jlc3MSEAoIaGVhZGxpbmUYASABKAkSJgoFdXNhZ2UYAyABKAsyFy52aXRlc3NlLmFpLnYxLlJ1blVzYWdlEigKBnN0YXR1cxgEIAEoDjIYLnZpdGVzc2UuYWkudjEuUnVuU3RhdHVzEhEKCXN0ZWVyX3NlcRgGIAEoBBIPCgdwYXJ0aWFsGAcgASgJSgQIAhADSgQIBRAGIh8KDVJ1bkludmFsaWRhdGUSDgoGcmVhc29uGAEgASgJIl4KC1J1bldhdmVTdGVwEh4KFnByaW9yX2RlbGl2ZXJhYmxlX2pzb24YASABKAkSHQoVbmV4dF9kZWxpdmVyYWJsZV9qc29uGAIgASgJEhAKCGVzY2FsYXRlGAMgASgIIvQBCgtSdW5NdXRhdGlvbhIOCgZydW5faWQYASABKAkSDQoFZXBvY2gYAiABKAQSKAoFc3RhcnQYAyABKAsyFy52aXRlc3NlLmFpLnYxLkFnZW50UnVuSAASLgoIcHJvZ3Jlc3MYBCABKAsyGi52aXRlc3NlLmFpLnYxLlJ1blByb2dyZXNzSAASLAoGZmluaXNoGAUgASgLMhoudml0ZXNzZS5haS52MS5BZ2VudFJldHVybkgAEiwKB2NvbnRyb2wYBiABKAsyGS52aXRlc3NlLmFpLnYxLlJ1bkNvbnRyb2xIAEIECgJvcEoECAcQCEoECAgQCSLiAgoLT3duZXJBY3Rpb24SDgoGcnVuX2lkGAEgASgJEi0KBGtpbmQYAiABKA4yHy52aXRlc3NlLmFpLnYxLk93bmVyQWN0aW9uLktpbmQSDgoGcmVhc29uGAMgASgJEjAKCmludmFsaWRhdGUYBCABKAsyHC52aXRlc3NlLmFpLnYxLlJ1bkludmFsaWRhdGUSKAoEd2F2ZRgFIAEoCzIaLnZpdGVzc2UuYWkudjEuUnVuV2F2ZVN0ZXASFAoMdG9vbF9jYWxsX2lkGAYgASgJEhcKD2NvbnZlcnNhdGlvbl9pZBgHIAEoCSJ5CgRLaW5kEhQKEEtJTkRfVU5TUEVDSUZJRUQQABIOCgpLSU5EX0FCT1JUEAESEQoNS0lORF9IQUxUX0FMTBACEhMKD0tJTkRfSU5WQUxJREFURRADEg0KCUtJTkRfV0FWRRAEEhQKEEtJTkRfQ0FOQ0VMX1dBSVQQBSLOAQoQT3duZXJBY3Rpb25SZXBseRIiCgZyZXN1bHQYASABKAsyEi52aXRlc3NlLnYxLlJlc3VsdBIYChBhZmZlY3RlZF9ydW5faWRzGAIgAygJEhoKEmVzdGltYXRlZF9jb3N0X3VzZBgDIAEoARIyCgd2ZXJkaWN0GAQgASgOMiEudml0ZXNzZS5haS52MS5Qcm9wYWdhdGlvblZlcmRpY3QSEwoLbmV4dF9ydW5faWQYBSABKAkSFwoPY2xlYXJlZF9ydW5faWRzGAYgAygJItsBChBSdW5NdXRhdGlvblJlcGx5EiIKBnJlc3VsdBgBIAEoCzISLnZpdGVzc2UudjEuUmVzdWx0EiQKA3J1bhgCIAEoCzIXLnZpdGVzc2UuYWkudjEuQWdlbnRSdW4SGAoQYWZmZWN0ZWRfcnVuX2lkcxgDIAMoCRIaChJlc3RpbWF0ZWRfY29zdF91c2QYBCABKAESMgoHdmVyZGljdBgFIAEoDjIhLnZpdGVzc2UuYWkudjEuUHJvcGFnYXRpb25WZXJkaWN0EhMKC25leHRfcnVuX2lkGAYgASgJIskCCg9UcmVlVmlld1JlcXVlc3QSEwoLcm9vdF9ydW5faWQYASABKAkSEAoIc2luY2VfbnMYAiABKAQSEQoJd2FudF9ydW5zGAMgASgIEhMKC3dhbnRfZGlnZXN0GAQgASgIEhUKDXdhbnRfZGFuZ2xpbmcYBSABKAgSEgoKd2FudF9zdGFsZRgGIAEoCBIdChVpbmplY3Rpb25fZnJvbV9ydW5faWQYByABKAkSFAoMd2FudF9vcnBoYW5zGAggASgIEhcKD3dhbnRfaW5qZWN0aW9ucxgJIAEoCBIcChRpbmplY3Rpb25zX3NpbmNlX3NlcRgKIAEoBBITCgt3YW50X2ZvcmVzdBgLIAEoCBIVCg13YW50X21lc3NhZ2VzGAwgASgIEiQKHHNwYXduZWRfZnJvbV9jb252ZXJzYXRpb25faWQYDSABKAki9QIKDVRyZWVWaWV3UmVwbHkSIgoGcmVzdWx0GAEgASgLMhIudml0ZXNzZS52MS5SZXN1bHQSJQoEcnVucxgCIAMoCzIXLnZpdGVzc2UuYWkudjEuQWdlbnRSdW4SKQoGZGlnZXN0GAMgASgLMhkudml0ZXNzZS5haS52MS5UcmVlRGlnZXN0EjEKCGRhbmdsaW5nGAQgAygLMh8udml0ZXNzZS5haS52MS5EYW5nbGluZ1Rvb2xDYWxsEhUKDXN0YWxlX3J1bl9pZHMYBSADKAkSHwoXaW5qZWN0aW9uX3RhcmdldF9ydW5faWQYBiABKAkSGwoTb3JwaGFuX3Jvb3RfcnVuX2lkcxgHIAMoCRIzCgppbmplY3Rpb25zGAggAygLMh8udml0ZXNzZS5haS52MS5QZW5kaW5nSW5qZWN0aW9uEjEKCG1lc3NhZ2VzGAkgAygLMh8udml0ZXNzZS5haS52MS5BZ2VudE1lc3NhZ2VFZGdlIloKEEFnZW50TWVzc2FnZUVkZ2USEwoLZnJvbV9ydW5faWQYASABKAkSEQoJdG9fcnVuX2lkGAIgASgJEg0KBWF0X25zGAMgASgDEg8KB3BlbmRpbmcYBCABKAgikwEKEFBlbmRpbmdJbmplY3Rpb24SDgoGcnVuX2lkGAEgASgJEhcKD2NvbnZlcnNhdGlvbl9pZBgCIAEoCRILCgNzZXEYAyABKAQSDAoEdGV4dBgEIAEoCRINCgVhdF9ucxgGIAEoAxITCgtmcm9tX3J1bl9pZBgHIAEoCRIRCglmcm9tX25hbWUYCCABKAlKBAgFEAYingEKEERhbmdsaW5nVG9vbENhbGwSFAoMdG9vbF9jYWxsX2lkGAEgASgJEgwKBG5hbWUYAiABKAkSEgoKaW5wdXRfanNvbhgDIAEoCRIXCg9jb252ZXJzYXRpb25faWQYBCABKAkSEgoKbWVzc2FnZV9pZBgFIAEoCRILCgNzZXEYBiABKAQSGAoQZGlzcGF0Y2hlZF9hdF9ucxgHIAEoAyLAAQoIUnVuTGVhc2USEwoLcm9vdF9ydW5faWQYASABKAkSEQoJZHJpdmVyX2lkGAIgASgJEioKBGtpbmQYAyABKA4yHC52aXRlc3NlLmFpLnYxLlJ1bkxlYXNlLktpbmQSEAoIdW50aWxfbXMYBCABKAMSDQoFZXBvY2gYBSABKAQiPwoES2luZBIUChBLSU5EX1VOU1BFQ0lGSUVEEAASEAoMS0lORF9CUk9XU0VSEAESDwoLS0lORF9TRVJWRVIQAiKLAgoKRGlnZXN0Tm9kZRIOCgZydW5faWQYASABKAkSDQoFbGFiZWwYAiABKAkSEAoIaGVhZGxpbmUYAyABKAkSDQoFZGVwdGgYBCABKA0SFQoNcGFyZW50X3J1bl9pZBgFIAEoCRIoCgZzdGF0dXMYBiABKA4yGC52aXRlc3NlLmFpLnYxLlJ1blN0YXR1cxI2Cg90ZXJtaW5hbF9yZWFzb24YByABKA4yHS52aXRlc3NlLmFpLnYxLlRlcm1pbmFsUmVhc29uEhIKCmVsYXBzZWRfbXMYCCABKAMSEAoIY29zdF91c2QYCSABKAESDwoHY2hhbmdlZBgKIAEoCBINCgVzdGFsZRgLIAEoCCKYAgoKVHJlZURpZ2VzdBITCgtyb290X3J1bl9pZBgBIAEoCRISCgp0b3RhbF9ydW5zGAIgASgNEg8KB3J1bm5pbmcYAyABKA0SEAoIYXdhaXRpbmcYBCABKA0SDgoGcXVldWVkGAUgASgNEhAKCGZpbmlzaGVkGAYgASgNEi4KDXN1YnRyZWVfdXNhZ2UYByABKAsyFy52aXRlc3NlLmFpLnYxLlJ1blVzYWdlEigKBW5vZGVzGAggAygLMhkudml0ZXNzZS5haS52MS5EaWdlc3ROb2RlEgwKBHRleHQYCSABKAkSEwoLY2hhbmdlX25vdGUYCiABKAkSEAoIc2luY2VfbnMYCyABKAMSDQoFYXRfbnMYDCABKAMinwEKClJ1bkNvbnRyb2wSDgoGcnVuX2lkGAEgASgJEjAKBmFjdGlvbhgCIAEoDjIgLnZpdGVzc2UuYWkudjEuUnVuQ29udHJvbC5BY3Rpb24SDgoGcmVhc29uGAMgASgJIj8KBkFjdGlvbhIWChJBQ1RJT05fVU5TUEVDSUZJRUQQABIRCg1BQ1RJT05fQ0FOQ0VMEAEiBAgCEAIiBAgDEAMibgoPQWlJbnZva2VSZXF1ZXN0EhEKCWV4cGVydF9pZBgBIAEoCRIRCglvYmplY3RpdmUYAiABKAkSEgoKaW5wdXRfanNvbhgDIAEoCRIPCgd0cmlnZ2VyGAQgASgJEhAKCG1vZGVsX2lkGAUgASgJIkgKDk1jcFRvb2xSZXF1ZXN0EgwKBHRvb2wYASABKAkSFgoOYXJndW1lbnRzX2pzb24YAiABKAkSEAoIbW9kZWxfaWQYAyABKAkiYgoMTWNwVG9vbFJlcGx5EiIKBnJlc3VsdBgBIAEoCzISLnZpdGVzc2UudjEuUmVzdWx0EgoKAm9rGAIgASgIEg8KB21lc3NhZ2UYAyABKAkSEQoJZGF0YV9qc29uGAQgASgJIloKDUFpSW52b2tlUmVwbHkSIgoGcmVzdWx0GAEgASgLMhIudml0ZXNzZS52MS5SZXN1bHQSEgoKdmFsdWVfanNvbhgCIAEoCRIRCgl0aW1lZF9vdXQYAyABKAgqiAEKCVJ1blN0YXR1cxIaChZSVU5fU1RBVFVTX1VOU1BFQ0lGSUVEEAASFQoRUlVOX1NUQVRVU19RVUVVRUQQARIWChJSVU5fU1RBVFVTX1JVTk5JTkcQAhIXChNSVU5fU1RBVFVTX0FXQUlUSU5HEAMSFwoTUlVOX1NUQVRVU19GSU5JU0hFRBAEKsgCCg5UZXJtaW5hbFJlYXNvbhIfChtURVJNSU5BTF9SRUFTT05fVU5TUEVDSUZJRUQQABIdChlURVJNSU5BTF9SRUFTT05fQ09NUExFVEVEEAESHAoYVEVSTUlOQUxfUkVBU09OX1NURVBfQ0FQEAISGgoWVEVSTUlOQUxfUkVBU09OX0JVREdFVBADEh4KGlRFUk1JTkFMX1JFQVNPTl9OT19DUkVESVRTEAgSHQoZVEVSTUlOQUxfUkVBU09OX0NBTkNFTExFRBAFEhsKF1RFUk1JTkFMX1JFQVNPTl9BQk9SVEVEEAYSGQoVVEVSTUlOQUxfUkVBU09OX0VSUk9SEAcSHQoZVEVSTUlOQUxfUkVBU09OX05PX09VVFBVVBAJEiAKHFRFUk1JTkFMX1JFQVNPTl9UT09MX0ZBSUxJTkcQCiIECAQQBCqfAQoSUHJvcGFnYXRpb25WZXJkaWN0EiMKH1BST1BBR0FUSU9OX1ZFUkRJQ1RfVU5TUEVDSUZJRUQQABIgChxQUk9QQUdBVElPTl9WRVJESUNUX0NPTlRJTlVFEAESHwobUFJPUEFHQVRJT05fVkVSRElDVF9DVVRfT0ZGEAISIQodUFJPUEFHQVRJT05fVkVSRElDVF9FU0NBTEFURUQQA0K9AQoRY29tLnZpdGVzc2UuYWkudjFCCkFnZW50UHJvdG9QAVpGZ2l0aHViLmNvbS9Nb3ZlbmRpLWFpL3ZpdGVzc2UtcGxhdGZvcm0vcHJvdG8vZ2VuL2dvL3ZpdGVzc2UvYWkvdjE7YWl2MaICA1ZBWKoCDVZpdGVzc2UuQWkuVjHKAg1WaXRlc3NlXEFpXFYx4gIZVml0ZXNzZVxBaVxWMVxHUEJNZXRhZGF0YeoCD1ZpdGVzc2U6OkFpOjpWMWIGcHJvdG8z", [file_vitesse_v1_common]);
/**
 * Describes the message vitesse.ai.v1.RunConstraints.
 * Use `create(RunConstraintsSchema)` to create a new message.
 */
export const RunConstraintsSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 0);
/**
 * Describes the message vitesse.ai.v1.AgentTask.
 * Use `create(AgentTaskSchema)` to create a new message.
 */
export const AgentTaskSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 1);
/**
 * Describes the message vitesse.ai.v1.AgentReturn.
 * Use `create(AgentReturnSchema)` to create a new message.
 */
export const AgentReturnSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 2);
/**
 * Describes the message vitesse.ai.v1.RunUsage.
 * Use `create(RunUsageSchema)` to create a new message.
 */
export const RunUsageSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 3);
/**
 * Describes the message vitesse.ai.v1.AgentRun.
 * Use `create(AgentRunSchema)` to create a new message.
 */
export const AgentRunSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 4);
/**
 * Describes the message vitesse.ai.v1.RunEvent.
 * Use `create(RunEventSchema)` to create a new message.
 */
export const RunEventSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 5);
/**
 * @generated from enum vitesse.ai.v1.RunEvent.Kind
 */
export var RunEvent_Kind;
(function (RunEvent_Kind) {
    /**
     * @generated from enum value: KIND_UNSPECIFIED = 0;
     */
    RunEvent_Kind[RunEvent_Kind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * `run` carries the freshly-spawned node
     *
     * @generated from enum value: KIND_RUN_STARTED = 1;
     */
    RunEvent_Kind[RunEvent_Kind["RUN_STARTED"] = 1] = "RUN_STARTED";
    /**
     * the ≤7-word headline advanced; `headline` + `usage` (running rollup)
     *
     * @generated from enum value: KIND_STATUS = 2;
     */
    RunEvent_Kind[RunEvent_Kind["STATUS"] = 2] = "STATUS";
    /**
     * a model↔tool round trip completed
     *
     * @generated from enum value: KIND_STEP = 3;
     */
    RunEvent_Kind[RunEvent_Kind["STEP"] = 3] = "STEP";
    /**
     * `run` carries the terminal node incl. `ret`
     *
     * @generated from enum value: KIND_RUN_FINISHED = 5;
     */
    RunEvent_Kind[RunEvent_Kind["RUN_FINISHED"] = 5] = "RUN_FINISHED";
})(RunEvent_Kind || (RunEvent_Kind = {}));
/**
 * Describes the enum vitesse.ai.v1.RunEvent.Kind.
 */
export const RunEvent_KindSchema = /*@__PURE__*/ enumDesc(file_vitesse_ai_v1_agent, 5, 0);
/**
 * Describes the message vitesse.ai.v1.LeaseRequest.
 * Use `create(LeaseRequestSchema)` to create a new message.
 */
export const LeaseRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 6);
/**
 * @generated from enum vitesse.ai.v1.LeaseRequest.Action
 */
export var LeaseRequest_Action;
(function (LeaseRequest_Action) {
    /**
     * @generated from enum value: ACTION_UNSPECIFIED = 0;
     */
    LeaseRequest_Action[LeaseRequest_Action["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * adopt an unheld or expired lease; always bumps the fencing epoch
     *
     * @generated from enum value: ACTION_CLAIM = 1;
     */
    LeaseRequest_Action[LeaseRequest_Action["CLAIM"] = 1] = "CLAIM";
    /**
     * the driver's heartbeat — this IS the liveness signal
     *
     * @generated from enum value: ACTION_RENEW = 2;
     */
    LeaseRequest_Action[LeaseRequest_Action["RENEW"] = 2] = "RENEW";
    /**
     * voluntary hand-back, so the tree is adoptable in ms not a full TTL
     *
     * @generated from enum value: ACTION_RELEASE = 3;
     */
    LeaseRequest_Action[LeaseRequest_Action["RELEASE"] = 3] = "RELEASE";
})(LeaseRequest_Action || (LeaseRequest_Action = {}));
/**
 * Describes the enum vitesse.ai.v1.LeaseRequest.Action.
 */
export const LeaseRequest_ActionSchema = /*@__PURE__*/ enumDesc(file_vitesse_ai_v1_agent, 6, 0);
/**
 * Describes the message vitesse.ai.v1.LeaseReply.
 * Use `create(LeaseReplySchema)` to create a new message.
 */
export const LeaseReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 7);
/**
 * Describes the message vitesse.ai.v1.RunProgress.
 * Use `create(RunProgressSchema)` to create a new message.
 */
export const RunProgressSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 8);
/**
 * Describes the message vitesse.ai.v1.RunInvalidate.
 * Use `create(RunInvalidateSchema)` to create a new message.
 */
export const RunInvalidateSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 9);
/**
 * Describes the message vitesse.ai.v1.RunWaveStep.
 * Use `create(RunWaveStepSchema)` to create a new message.
 */
export const RunWaveStepSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 10);
/**
 * Describes the message vitesse.ai.v1.RunMutation.
 * Use `create(RunMutationSchema)` to create a new message.
 */
export const RunMutationSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 11);
/**
 * Describes the message vitesse.ai.v1.OwnerAction.
 * Use `create(OwnerActionSchema)` to create a new message.
 */
export const OwnerActionSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 12);
/**
 * @generated from enum vitesse.ai.v1.OwnerAction.Kind
 */
export var OwnerAction_Kind;
(function (OwnerAction_Kind) {
    /**
     * @generated from enum value: KIND_UNSPECIFIED = 0;
     */
    OwnerAction_Kind[OwnerAction_Kind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * stop this run and everything beneath it → TERMINAL_REASON_ABORTED
     *
     * @generated from enum value: KIND_ABORT = 1;
     */
    OwnerAction_Kind[OwnerAction_Kind["ABORT"] = 1] = "ABORT";
    /**
     * stop EVERY live run, across every tree. Takes no run_id: in an emergency
     *
     * @generated from enum value: KIND_HALT_ALL = 2;
     */
    OwnerAction_Kind[OwnerAction_Kind["HALT_ALL"] = 2] = "HALT_ALL";
    /**
     * nobody enumerates trees first. "Stop spending" is one action.
     *
     * an edit landed here — mark this run and every ancestor stale
     *
     * @generated from enum value: KIND_INVALIDATE = 3;
     */
    OwnerAction_Kind[OwnerAction_Kind["INVALIDATE"] = 3] = "INVALIDATE";
    /**
     * this stale run re-derived; does the wave keep climbing?
     *
     * @generated from enum value: KIND_WAVE = 4;
     */
    OwnerAction_Kind[OwnerAction_Kind["WAVE"] = 4] = "WAVE";
    /**
     * the person ended a run's wait early — resolves the open wait call
     *
     * @generated from enum value: KIND_CANCEL_WAIT = 5;
     */
    OwnerAction_Kind[OwnerAction_Kind["CANCEL_WAIT"] = 5] = "CANCEL_WAIT";
})(OwnerAction_Kind || (OwnerAction_Kind = {}));
/**
 * Describes the enum vitesse.ai.v1.OwnerAction.Kind.
 */
export const OwnerAction_KindSchema = /*@__PURE__*/ enumDesc(file_vitesse_ai_v1_agent, 12, 0);
/**
 * Describes the message vitesse.ai.v1.OwnerActionReply.
 * Use `create(OwnerActionReplySchema)` to create a new message.
 */
export const OwnerActionReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 13);
/**
 * Describes the message vitesse.ai.v1.RunMutationReply.
 * Use `create(RunMutationReplySchema)` to create a new message.
 */
export const RunMutationReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 14);
/**
 * Describes the message vitesse.ai.v1.TreeViewRequest.
 * Use `create(TreeViewRequestSchema)` to create a new message.
 */
export const TreeViewRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 15);
/**
 * Describes the message vitesse.ai.v1.TreeViewReply.
 * Use `create(TreeViewReplySchema)` to create a new message.
 */
export const TreeViewReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 16);
/**
 * Describes the message vitesse.ai.v1.AgentMessageEdge.
 * Use `create(AgentMessageEdgeSchema)` to create a new message.
 */
export const AgentMessageEdgeSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 17);
/**
 * Describes the message vitesse.ai.v1.PendingInjection.
 * Use `create(PendingInjectionSchema)` to create a new message.
 */
export const PendingInjectionSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 18);
/**
 * Describes the message vitesse.ai.v1.DanglingToolCall.
 * Use `create(DanglingToolCallSchema)` to create a new message.
 */
export const DanglingToolCallSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 19);
/**
 * Describes the message vitesse.ai.v1.RunLease.
 * Use `create(RunLeaseSchema)` to create a new message.
 */
export const RunLeaseSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 20);
/**
 * @generated from enum vitesse.ai.v1.RunLease.Kind
 */
export var RunLease_Kind;
(function (RunLease_Kind) {
    /**
     * @generated from enum value: KIND_UNSPECIFIED = 0;
     */
    RunLease_Kind[RunLease_Kind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * a tab's AI worker
     *
     * @generated from enum value: KIND_BROWSER = 1;
     */
    RunLease_Kind[RunLease_Kind["BROWSER"] = 1] = "BROWSER";
    /**
     * a headless runner — same lease, different holder
     *
     * @generated from enum value: KIND_SERVER = 2;
     */
    RunLease_Kind[RunLease_Kind["SERVER"] = 2] = "SERVER";
})(RunLease_Kind || (RunLease_Kind = {}));
/**
 * Describes the enum vitesse.ai.v1.RunLease.Kind.
 */
export const RunLease_KindSchema = /*@__PURE__*/ enumDesc(file_vitesse_ai_v1_agent, 20, 0);
/**
 * Describes the message vitesse.ai.v1.DigestNode.
 * Use `create(DigestNodeSchema)` to create a new message.
 */
export const DigestNodeSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 21);
/**
 * Describes the message vitesse.ai.v1.TreeDigest.
 * Use `create(TreeDigestSchema)` to create a new message.
 */
export const TreeDigestSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 22);
/**
 * Describes the message vitesse.ai.v1.RunControl.
 * Use `create(RunControlSchema)` to create a new message.
 */
export const RunControlSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 23);
/**
 * @generated from enum vitesse.ai.v1.RunControl.Action
 */
export var RunControl_Action;
(function (RunControl_Action) {
    /**
     * @generated from enum value: ACTION_UNSPECIFIED = 0;
     */
    RunControl_Action[RunControl_Action["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * parent-initiated → TERMINAL_REASON_CANCELLED
     *
     * @generated from enum value: ACTION_CANCEL = 1;
     */
    RunControl_Action[RunControl_Action["CANCEL"] = 1] = "CANCEL";
})(RunControl_Action || (RunControl_Action = {}));
/**
 * Describes the enum vitesse.ai.v1.RunControl.Action.
 */
export const RunControl_ActionSchema = /*@__PURE__*/ enumDesc(file_vitesse_ai_v1_agent, 23, 0);
/**
 * Describes the message vitesse.ai.v1.AiInvokeRequest.
 * Use `create(AiInvokeRequestSchema)` to create a new message.
 */
export const AiInvokeRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 24);
/**
 * Describes the message vitesse.ai.v1.McpToolRequest.
 * Use `create(McpToolRequestSchema)` to create a new message.
 */
export const McpToolRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 25);
/**
 * Describes the message vitesse.ai.v1.McpToolReply.
 * Use `create(McpToolReplySchema)` to create a new message.
 */
export const McpToolReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 26);
/**
 * Describes the message vitesse.ai.v1.AiInvokeReply.
 * Use `create(AiInvokeReplySchema)` to create a new message.
 */
export const AiInvokeReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_ai_v1_agent, 27);
/**
 * @generated from enum vitesse.ai.v1.RunStatus
 */
export var RunStatus;
(function (RunStatus) {
    /**
     * @generated from enum value: RUN_STATUS_UNSPECIFIED = 0;
     */
    RunStatus[RunStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * spawned, not yet stepped — no tokens spent
     *
     * @generated from enum value: RUN_STATUS_QUEUED = 1;
     */
    RunStatus[RunStatus["QUEUED"] = 1] = "QUEUED";
    /**
     * @generated from enum value: RUN_STATUS_RUNNING = 2;
     */
    RunStatus[RunStatus["RUNNING"] = 2] = "RUNNING";
    /**
     * blocked — on `awaits` runs, or on the user via ask_user
     *
     * @generated from enum value: RUN_STATUS_AWAITING = 3;
     */
    RunStatus[RunStatus["AWAITING"] = 3] = "AWAITING";
    /**
     * terminal; read `terminal_reason` for WHICH terminal
     *
     * @generated from enum value: RUN_STATUS_FINISHED = 4;
     */
    RunStatus[RunStatus["FINISHED"] = 4] = "FINISHED";
})(RunStatus || (RunStatus = {}));
/**
 * Describes the enum vitesse.ai.v1.RunStatus.
 */
export const RunStatusSchema = /*@__PURE__*/ enumDesc(file_vitesse_ai_v1_agent, 0);
/**
 * WHY a run ended. The silent-failure fix: without this a parent cannot distinguish "my child
 * concluded X" from "my child ran out of road at X" and will act confidently on a truncated result.
 * Every terminal path names itself, and `AgentReturn.result.summary` explains it in prose.
 *
 * @generated from enum vitesse.ai.v1.TerminalReason
 */
export var TerminalReason;
(function (TerminalReason) {
    /**
     * @generated from enum value: TERMINAL_REASON_UNSPECIFIED = 0;
     */
    TerminalReason[TerminalReason["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * the agent decided it was done — the ONLY self-declared success
     *
     * @generated from enum value: TERMINAL_REASON_COMPLETED = 1;
     */
    TerminalReason[TerminalReason["COMPLETED"] = 1] = "COMPLETED";
    /**
     * hit `AgentTask.constraints.step_cap`
     *
     * @generated from enum value: TERMINAL_REASON_STEP_CAP = 2;
     */
    TerminalReason[TerminalReason["STEP_CAP"] = 2] = "STEP_CAP";
    /**
     * hit the credit/USD ceiling; in-flight work finished, nothing new spawned
     *
     * @generated from enum value: TERMINAL_REASON_BUDGET = 3;
     */
    TerminalReason[TerminalReason["BUDGET"] = 3] = "BUDGET";
    /**
     * The turn was REFUSED before it started: the owner's credit balance could not cover it. Distinct
     * from BUDGET, which is this run's own ceiling — a run can be well inside its budget and still be
     * unaffordable. Collapsing the two would tell a user "the agent hit its limit" when the truth is
     * "your account is empty", which is a different problem with a different fix.
     *
     * @generated from enum value: TERMINAL_REASON_NO_CREDITS = 8;
     */
    TerminalReason[TerminalReason["NO_CREDITS"] = 8] = "NO_CREDITS";
    /**
     * the PARENT abandoned it — its plan changed, not a user action
     *
     * @generated from enum value: TERMINAL_REASON_CANCELLED = 5;
     */
    TerminalReason[TerminalReason["CANCELLED"] = 5] = "CANCELLED";
    /**
     * the USER stopped it
     *
     * @generated from enum value: TERMINAL_REASON_ABORTED = 6;
     */
    TerminalReason[TerminalReason["ABORTED"] = 6] = "ABORTED";
    /**
     * unrecoverable failure; `result.error` carries code + remedy
     *
     * @generated from enum value: TERMINAL_REASON_ERROR = 7;
     */
    TerminalReason[TerminalReason["ERROR"] = 7] = "ERROR";
    /**
     * The model returned NOTHING, repeatedly. Distinct from STEP_CAP, which means "ran out of road
     * while working", and from ERROR, which means something broke: here every call succeeded and
     * produced no output.
     *
     * Observed on reasoning models whose entire token budget went to reasoning, leaving empty content
     * with `finish_reason: length`. The loop's bias is to over-run rather than conclude from output
     * nobody could read — correct when one more call might help, wrong here, because the loop resends
     * an identical request and gets an identical nothing while being billed for each. A run that
     * cannot produce output should say so rather than spend its cap discovering it.
     *
     * @generated from enum value: TERMINAL_REASON_NO_OUTPUT = 9;
     */
    TerminalReason[TerminalReason["NO_OUTPUT"] = 9] = "NO_OUTPUT";
    /**
     * The SAME TOOL failed over and over. Distinct from ERROR, where something broke and the run
     * could not continue, and from STEP_CAP, which means "ran out of road while working": here the
     * run was working, and the thing it kept reaching for kept refusing.
     *
     * The argument list is deliberately not part of the judgement. A model that cannot get a tool to
     * work rewrites its arguments every attempt, so counting (tool, arguments) pairs counts a new
     * pair each time and never trips — which is exactly what was observed: a specialist calling one
     * refusing tool until its cap, rewriting the call each turn, billed for every attempt.
     *
     * The allowance is larger than NO_OUTPUT's, on purpose. A refusal is INFORMATION — it says what
     * was wrong, and a model that reads it often fixes the call on the next turn, which is the loop
     * working as intended. An empty reply tells it nothing, so there is nothing to learn from and no
     * reason to pay for a third.
     *
     * @generated from enum value: TERMINAL_REASON_TOOL_FAILING = 10;
     */
    TerminalReason[TerminalReason["TOOL_FAILING"] = 10] = "TOOL_FAILING";
})(TerminalReason || (TerminalReason = {}));
/**
 * Describes the enum vitesse.ai.v1.TerminalReason.
 */
export const TerminalReasonSchema = /*@__PURE__*/ enumDesc(file_vitesse_ai_v1_agent, 1);
/**
 * Why a wave stopped climbing, recorded so the UI can say "your edit changed nothing above here"
 * rather than leaving a half-highlighted path with no explanation.
 *
 * @generated from enum vitesse.ai.v1.PropagationVerdict
 */
export var PropagationVerdict;
(function (PropagationVerdict) {
    /**
     * @generated from enum value: PROPAGATION_VERDICT_UNSPECIFIED = 0;
     */
    PropagationVerdict[PropagationVerdict["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * the declared deliverable changed — the parent must re-run
     *
     * @generated from enum value: PROPAGATION_VERDICT_CONTINUE = 1;
     */
    PropagationVerdict[PropagationVerdict["CONTINUE"] = 1] = "CONTINUE";
    /**
     * identical on every declared field — the parent's input never moved
     *
     * @generated from enum value: PROPAGATION_VERDICT_CUT_OFF = 2;
     */
    PropagationVerdict[PropagationVerdict["CUT_OFF"] = 2] = "CUT_OFF";
    /**
     * structurally identical, but the child flagged it significant
     *
     * @generated from enum value: PROPAGATION_VERDICT_ESCALATED = 3;
     */
    PropagationVerdict[PropagationVerdict["ESCALATED"] = 3] = "ESCALATED";
})(PropagationVerdict || (PropagationVerdict = {}));
/**
 * Describes the enum vitesse.ai.v1.PropagationVerdict.
 */
export const PropagationVerdictSchema = /*@__PURE__*/ enumDesc(file_vitesse_ai_v1_agent, 2);
//# sourceMappingURL=agent_pb.js.map